<template>
    <b-modal id="stacked-moments-modal"
             :visible="true"
             size="lg"
             :title="items.length ? $t('stackedmomentsmodal.title', { name: items[0]?.extendedProps?.Name?.toLowerCase() }) : ''"
             hide-footer
             @hidden="$emit('close')">
        <b-list-group>
            <b-list-group-item v-for="item in items"
                               :key="item.id"
                               :button="!item.ending"
                               :class="{ 'ending-soon': item.ending }"
                               class="d-flex justify-content-between align-items-center"
                               @click="openReservationModal(item)">
                <div>
                    <div>
                        <strong>
                            {{ format(new Date(item.start), 'HH:mm') }} - {{ format(new Date(item.originalEnd || item.end), 'HH:mm') }}
                        </strong>
                    </div>
                    <div v-if="item.extendedProps['Location.Name']"
                         class="small">
                        {{ item.extendedProps['Location.Name'] }}
                    </div>
                    <div v-if="getMomentStatus(item)?.date">
                        <span v-if="getMomentStatus(item)?.identification === 'reservations_open_at' || getMomentStatus(item)?.identification === 'reservations_closed_at'"
                              class="text-info">
                            <font-awesome-icon :icon="icons.faInfoCircle" />
                            {{ $t('timetable.' + getMomentStatus(item).identification, { date: format(getMomentStatus(item).date,
                                                                                                      new Date(getMomentStatus(item).date).toDateString() === new Date().toDateString()
                                                                                                          ? `HH:mm`
                                                                                                          : `dd-MM-yyyy '${$t('common.at')}' HH:mm`
                            ) }) }}
                        </span>
                    </div>
                </div>
                <template v-if="getMomentStatus(item)">
                    <div>
                        <b-button size="sm"
                                  :variant="getMomentStatus(item).variant"
                                  :disabled="!getMomentStatus(item).canReserve"
                                  @click.stop="openReservationModal(item)">
                            {{ getMomentStatus(item).text }}
                            <span v-if="getMomentStatus(item).showQueueCount && item.extendedProps.QueueQuantity > 0"
                                  class="badge badge-pill badge-light">
                                {{ item.extendedProps.QueueQuantity }}
                            </span>
                        </b-button>
                    </div>
                </template>
                <template v-else-if="!item.ending">
                    <b-button size="sm"
                              variant="outline-primary"
                              @click.stop="openReservationModal(item)">
                        {{ $t('actions.view') }}
                    </b-button>
                </template>
            </b-list-group-item>
        </b-list-group>
    </b-modal>
</template>

<script>
import { format } from 'date-fns'
import reservationStatusMixin from './mixins/reservationStatusMixin'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'StackedMomentsModal',

  components: {
    FontAwesomeIcon
  },

  mixins: [reservationStatusMixin],

  props: {
    mainItem: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      isStackedMomentsModal: true,
      format,
      icons: {
        faInfoCircle
      },
      dontAllowReservationForIds: [
        'reservations_open_at',
        'reservations_closed_at'
      ]
    }
  },

  computed: {
    items () {
      if (!this.mainItem) return []

      return [
        this.mainItem,
        ...this.mainItem.children
      ].map(item => ({
        ...item,
        ending: this.isEventPassed(item)
      })).sort((a, b) => new Date(a.start) - new Date(b.start))
    }
  },

  methods: {
    isEventPassed (event) {
      const now = new Date()
      const eventEnd = new Date(event.end)

      return eventEnd <= now
    },

    openReservationModal (item) {
      if (item.ending || this.dontAllowReservationForIds.includes(this.getMomentStatus(item)?.identification)) return
      this.$emit('select-moment', { moment: item, stacked: this.mainItem.children?.length ? this.mainItem : false })
    }
  }
}
</script>
